import { render, staticRenderFns } from "./ProjectCommentField.vue?vue&type=template&id=0f5b8b7a"
import script from "./ProjectCommentField.vue?vue&type=script&lang=js"
export * from "./ProjectCommentField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports